// extracted by mini-css-extract-plugin
export default {"bypass":"BypassBlock_bypass__UnpB0","blocklist":"BypassBlock_blocklist__hXp3r"};